export default __webpack_public_path__ + "7cefc9957031006078af9e7cf220fe86.svg";